import {USER_FOUND} from "redux-oidc";

const FetchUsersAction = {
	Request: 'FetchUsersActionRequest',
	Success: 'FetchUsersActionSuccess',
	Failure: 'FetchUsersActionFailure'
};

const CreateUserAction = {
	Request: 'CreateUserActionRequest',
	Success: 'CreateUserActionSuccess',
	Failure: 'CreateUserActionFailure'
};

const UpdateUserAction = {
	Request: 'UpdateUserActionRequest',
	Success: 'UpdateUserActionSuccess',
	Failure: 'UpdateUserActionFailure'
};

const UnloadUserAction = {
	Request: 'UnloadUserActionRequest',
	Success: 'UnloadUserActionSuccess',
	Failure: 'UnloadUserActionFailure'
};

const FetchUserAction = {
	Request: 'FetchUserActionRequest',
	Success: 'FetchUserActionSuccess',
	Failure: 'FetchUserActionFailure'
};

const LoginUserAction = {
	Request: 'LoginUserActionRequest',
	Success: 'LoginUserActionSuccess',
	Failure: 'LoginUserActionFailure'
};

const InitialLoginUserAction = {
	Request: 'InitialLoginUserActionRequest',
	Success: 'InitialLoginUserActionSuccess',
	Failure: 'InitialLoginUserActionFailure'
};

const LogoutUserAction = {
	Request: 'LogoutUserActionRequest',
	Success: 'LogoutUserActionSuccess',
	Failure: 'LogoutUserActionFailure'
}

function fetchUsers(page = 0, size = 20) {
	return {
		type: FetchUsersAction.Request,
		payload: {
			page,
			size
		}
	};
}

function createUser(user) {
	return {
		type: CreateUserAction.Request,
		payload: user
	};
}

function updateUser(user) {
	return {
		type: UpdateUserAction.Request,
		payload: user
	};
}

function unloadUser() {
	return {
		type: UnloadUserAction.Request
	};
}

function fetchUser(id) {
	return {
		type: FetchUserAction.Request,
		payload: id
	};
}

function loginUser(auth) {
	return {
		type: LoginUserAction.Request,
		payload: auth
	};
}

function initialLoginUser(url) {
	return {
		type: InitialLoginUserAction.Request,
		payload: url
	};
}

function logoutUser() {
	return {
		type: LogoutUserAction.Request
	}
}

function storeUser(user) {
	return {
		type: USER_FOUND,
		payload: user
	}
}

export const UserActionCreators = {
	fetchUsers,
	createUser,
	updateUser,
	unloadUser,
	fetchUser,
	loginUser,
	initialLoginUser,
	logoutUser,
	storeUser
};

export const UserActions = {
	FetchUsersAction,
	CreateUserAction,
	UpdateUserAction,
	UnloadUserAction,
	FetchUserAction,
	LoginUserAction,
	InitialLoginUserAction,
	LogoutUserAction
};
